import type { Question } from '../../types';

// ---------------------------------------------------------------------------
// Manufacturing / Product Liability Supplement
// Conditioned on industry_type eq 'manufacturing'
// ---------------------------------------------------------------------------

const C = [{ field: 'industry_type', operator: 'eq' as const, value: 'manufacturing' }];

export const manufacturingQuestions: Question[] = [
  {
    id: 'mfg_products',
    text: 'What products do you manufacture?',
    section: 'supplement',
    group: 'mfg_operations',
    sort_order: 10,
    field_type: 'textarea',
    placeholder: 'Describe your products and what they are used for.',
    required: true,
    field_path: 'supplement.manufacturing.products',
    conditions: C,
    tags: ['supplement', 'manufacturing'],
  },
  {
    id: 'mfg_annual_sales',
    text: 'Annual gross sales',
    section: 'supplement',
    group: 'mfg_financials',
    sort_order: 20,
    field_type: 'currency',
    prefix: '$',
    placeholder: '2000000',
    required: true,
    field_path: 'supplement.manufacturing.annual_sales',
    conditions: C,
    tags: ['supplement', 'manufacturing'],
  },
  {
    id: 'mfg_sold_to',
    text: 'Who are your products sold to?',
    section: 'supplement',
    group: 'mfg_operations',
    sort_order: 30,
    field_type: 'multiselect',
    required: true,
    options: [
      { value: 'wholesale', label: 'Wholesalers / distributors' },
      { value: 'retail', label: 'Retailers' },
      { value: 'direct_consumer', label: 'Direct to consumers' },
      { value: 'oem', label: 'OEM / other manufacturers' },
      { value: 'government', label: 'Government / military' },
    ],
    field_path: 'supplement.manufacturing.sold_to',
    conditions: C,
    tags: ['supplement', 'manufacturing'],
  },
  {
    id: 'mfg_exports',
    text: 'Do you export products outside the U.S.?',
    section: 'supplement',
    group: 'mfg_operations',
    sort_order: 40,
    field_type: 'boolean',
    required: true,
    field_path: 'supplement.manufacturing.exports',
    conditions: C,
    tags: ['supplement', 'manufacturing'],
  },
  {
    id: 'mfg_safety_critical',
    text: 'Are any products used in safety-critical applications (aircraft, medical, automotive, firearms)?',
    section: 'supplement',
    group: 'mfg_risk',
    sort_order: 50,
    field_type: 'boolean',
    required: true,
    field_path: 'supplement.manufacturing.safety_critical',
    conditions: C,
    tags: ['supplement', 'manufacturing', 'product_liability'],
  },
  {
    id: 'mfg_recall_plan',
    text: 'Do you have a written product recall plan?',
    section: 'supplement',
    group: 'mfg_risk',
    sort_order: 60,
    field_type: 'boolean',
    required: true,
    field_path: 'supplement.manufacturing.recall_plan',
    conditions: C,
    tags: ['supplement', 'manufacturing'],
  },
  {
    id: 'mfg_qa_program',
    text: 'Do you maintain a documented quality-assurance / inspection program?',
    section: 'supplement',
    group: 'mfg_risk',
    sort_order: 70,
    field_type: 'boolean',
    required: true,
    field_path: 'supplement.manufacturing.qa_program',
    conditions: C,
    tags: ['supplement', 'manufacturing'],
  },
  {
    id: 'mfg_hold_harmless',
    text: 'Do you obtain hold-harmless agreements and certificates of insurance from your component suppliers?',
    section: 'supplement',
    group: 'mfg_risk',
    sort_order: 80,
    field_type: 'boolean',
    required: false,
    field_path: 'supplement.manufacturing.supplier_hold_harmless',
    conditions: C,
    tags: ['supplement', 'manufacturing'],
  },
  {
    id: 'mfg_employees',
    text: 'Number of production employees',
    section: 'supplement',
    group: 'mfg_employees',
    sort_order: 90,
    field_type: 'number',
    placeholder: '25',
    required: true,
    validation: { min: 0, max: 5000 },
    field_path: 'supplement.manufacturing.production_employees',
    conditions: C,
    tags: ['supplement', 'manufacturing'],
  },
  {
    id: 'mfg_prior_recalls',
    text: 'Have you had any product recalls or product-related claims in the past 5 years?',
    section: 'supplement',
    group: 'mfg_risk',
    sort_order: 100,
    field_type: 'boolean',
    required: true,
    field_path: 'supplement.manufacturing.prior_recalls',
    conditions: C,
    tags: ['supplement', 'manufacturing'],
  },
];
